import {Component} from "@angular/core";
import {DxBaseCellRenderComponent} from "../dx-base-cell-render.component";
import {ICellRendererParams} from "ag-grid-community";
import {DxGridColumn} from "../../../../domain/ui-options/column/dx-grid-column";


@Component({
  selector: 'dx-currency-cell-render',
  templateUrl: './dx-currency-cell-render.component.html',
  styleUrls: ['./dx-currency-cell-render.component.css']
})
export class DxCurrencyCellRenderComponent extends DxBaseCellRenderComponent {
  constructor() {
    super();
  }

  public highlightClass: string = '';

  protected _init(params: ICellRendererParams): void {
    super._init(params);
    this.value = this.transform(this._params.value);
    if ((<DxGridColumn>this._params.columnOptions).dataType.highlightNegatives && this._params.value < 0)
      this.highlightClass = 'highlight';
  }

  public transform(value: any): string {
    if((value !==0) && !value) return undefined;
    if (typeof (value) == 'string') value = parseFloat(value);
    let parts = value.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join(',');
  }
}
